import {
  ADD_SPACE,
  ELIMINATE_CREDIT_CARD_DEBT,
  EMERGENCY_RESERVE,
  EUROTRIP,
  EXPLORE_INVESTMENTS,
  HOME_IMPROVEMENTS,
  SOLAR_PANELS,
  STUDENT_DEBT
} from '../../../../constants/gems'
import Gems from '../../Gem/gems'

const gemNames = [
  EMERGENCY_RESERVE,
  HOME_IMPROVEMENTS,
  ADD_SPACE,
  STUDENT_DEBT,
  ELIMINATE_CREDIT_CARD_DEBT,
  SOLAR_PANELS,
  EUROTRIP,
  EXPLORE_INVESTMENTS
]

export default gemNames.map(name => Gems[name])
